import { useContext } from 'react'
import { VodContentContext } from '@/features/VOD/context/UseGetVodContextContext/VodContentContext'

export const useVodContentContext = () => {
    const context = useContext(VodContentContext)
    if (context === undefined) {
        throw new Error(
            'useVodItemsContext must be used within a VodItemsProvider'
        )
    }
    return context
}
